__turbopack_context__.v({
  "li": "list-module-scss-module__IiNRAW__li",
  "ol": "list-module-scss-module__IiNRAW__ol",
  "ul": "list-module-scss-module__IiNRAW__ul",
});
